import {
  requestPostFile,
  requestGet,
  requestPost,
  requestPut,
  requestDelete,
  requestPostFileBlob,
} from "../config/Api";

export const uploadNotificationCertificateZip = (formData) => {
  return requestPostFile("/notification/certificates/upload", formData);
};

export const getNotificationCertificates = (params) =>
  requestGet("/notification/certificates/", { params });

export const getNotificationCertificate = (id) =>
  requestGet(`/notification/certificates/${id}`);

export const updateNotificationCertificate = (id, data) =>
  requestPut(`/notification/certificates/${id}`, data);

export const deleteNotificationCertificate = (id) =>
  requestDelete(`/notification/certificates/${id}`);

export const downloadNotificationCertificateFile = (id) =>
  requestPostFileBlob(`/notification/certificates/download/${id}`, {});

export const uploadUpdateNotificationCertificate = (formData) =>
  requestPostFile("/notification/certificates/upload/update", formData);

export const uploadDeleteNotificationCertificate = (formData) =>
  requestPostFile("/notification/certificates/upload/delete", formData);

export const downloadNotificationCertificateReport = (payload) =>
  requestPostFileBlob("/notification/certificates/export", payload);

export const getNotificationCertificateFailures = (params) =>
  requestGet("/notification/certificates/failures", { params });

export const uploadGenerateNotificationCertificates = (formData) =>
  requestPostFile("/notification/certificates/generate", formData);

export const previewGenerateNotificationCertificates = (formData) =>
  requestPostFile("/notification/certificates/preview", formData);

export const changeNotificationCertificateStatus = (id, formData) => {
  return requestPostFile(
    `/notification/certificates/change/status/${id}`,
    formData,
  );
};

export const downloadGeneratedNotificationCertificatesMergedPdf = (formData) =>
  requestPostFileBlob(
    "/notification/certificates/download/generated/pdf",
    formData,
  );

export const createSingleNotificationCertificateStageOne = (id, data) => {
  return requestPost(
    `/notification/certificate/legal/file//generate/stage/one/${id}`,
    data,
  );
};

export const getNotificationCertificateByBarcode = (barcode) => {
  return requestGet(`/notification/certificate/barcode`, { barcode });
};

export const massChangeNotificationCertificateToSent = (payload) => {
  return requestPost(`/notification/certificates/mass/sent`, payload);
};

export const uploadNotificationCertificateOnline = (formData) => {
  return requestPostFile(`/notification/certificates/upload/online`, formData);
};

export const previewNotificationCertificateOnlineLawyers = (formData) => {
  return requestPostFile(
    `/notification/certificates/upload/online/preview-lawyers`,
    formData
  );
};

export const createNotificationCertificateFromOperation = (legalFileId, formData) => {
  return requestPostFile(
    `/notification/certificate/legal/file/generate/from/operation/${legalFileId}`,
    formData,
  );
};
